import React, { memo, useCallback } from "react";
import { FiltersMain } from "./styles/FilterButtonsStyles";

const FilterButtons = ({
  ButtonsArray = [],
  activeButton,
  setactiveButton,
  setCurrentPage = () => {},
}) => {
  const handleButtonClick = useCallback(
    (index) => {
      setactiveButton(index);
      setCurrentPage(1);
    },
    [setactiveButton]
  );
  return (
    <FiltersMain>
      <ul>
        {ButtonsArray?.map((value, index) => {
          return (
            <>
              <li
                key={value.title}
                className={activeButton === index ? "active" : ""}
                onClick={() => handleButtonClick(index)}
              >
                {value.title}
              </li>
            </>
          );
        })}
      </ul>
    </FiltersMain>
  );
};

export default memo(FilterButtons);
